import styled from 'styled-components/macro'

const RemoveIcon = styled.i`
  font-size: 14px;
  position: absolute;
  top: 0;
  right: 0;
  line-height: 9px;
  padding: 7px;
  cursor: pointer;
`

export default RemoveIcon
